/* Тексты страницы «Политика конфиденциальности». Разделы нумеруются автоматически при отрисовке. */

const en = {
  title: "Privacy policy",
  subtitle: "Processing and Protection of Personal Data on www.flyashgabat.com",
  meta: [
    { label: "Data controller", value: "Jahankeshde Hyzmat P.E. (Individual Enterprise \"Jahankeshde Hyzmat\")" },
    { label: "Website", value: "https://www.flyashgabat.com" },
    { label: "Version", value: "1.0 — draft for legal review" },
    { label: "Effective date", value: "20.08.2026" },
  ],
  sections: [
    {
      title: "Scope and Data Controller",
      blocks: [
        {
          type: "text",
          text: "This Privacy Policy (the \"Policy\") explains how Individual Enterprise \"Jahankeshde Hyzmat\", operating under the FlyAshgabat brand (the \"Company\", \"we\", \"us\" or \"our\"), collects, uses, stores, discloses and protects personal data in connection with www.flyashgabat.com (the \"Website\") and related travel, destination management and corporate travel services.",
        },
        {
          type: "text",
          text: "The Company is established under the laws of Turkmenistan and is the data controller for the processing described in this Policy, except where another person independently determines the purposes and means of processing, for example an airline, hotel, payment provider or public authority.",
        },
        {
          type: "text",
          text: "This Policy applies to Website visitors, registered users, customers, passengers, travellers, corporate contacts and other individuals whose personal data is provided to or obtained by the Company. Contact details for privacy enquiries are set out in Section 19.",
        },
        {
          type: "text",
          text: "This Policy is intended to provide transparent information. Use of the Website acknowledges that the User has had an opportunity to read this Policy; it does not replace consent where the law requires specific, freely given consent for a particular processing activity.",
        },
        {
          type: "text",
          text: "The primary legal framework is the law of Turkmenistan, including the Law of Turkmenistan \"On Information about Private Life and its Protection\". Where a particular processing activity falls within their territorial scope, the Company also applies Regulation (EU) 2016/679 (the \"GDPR\") and Law No. 6698 of the Republic of Turkiye on the Protection of Personal Data (the \"KVKK\"), together with other mandatory rules.",
        },
      ],
    },
    {
      title: "Key Terms and Principles",
      blocks: [
        {
          type: "text",
          text: "Personal data — any information relating to an identified or identifiable natural person.",
        },
        {
          type: "text",
          text: "Processing — any operation performed on personal data, including collection, recording, organisation, storage, use, disclosure, transfer, restriction and deletion.",
        },
        {
          type: "text",
          text: "User — a Website visitor, account holder, customer, passenger, traveller, corporate contact or another individual using the Company's services.",
        },
        {
          type: "text",
          text: "Supplier — an airline, hotel, carrier, booking system, tour operator, insurer, payment provider, transfer provider, excursion provider or another independent provider involved in a Service.",
        },
        {
          type: "text",
          text: "The Company processes personal data lawfully, fairly and transparently; for specified purposes; only to the extent reasonably necessary; with appropriate accuracy, retention limits and security; and in a manner that enables accountability.",
        },
      ],
    },
    {
      title: "Personal Data We Process",
      blocks: [
        {
          type: "text",
          text: "Depending on how the User interacts with FlyAshgabat and which Services are requested, the Company may process the following categories of personal data:",
        },
        {
          type: "list",
          items: [
            "identity data, including full name, date of birth, gender, nationality and customer or account identifiers;",
            "contact data, including email address, telephone number, postal address, country and preferred language;",
            "account data, including login credentials, verification codes, profile information and saved preferences;",
            "booking and travel data, including itinerary, dates, airports, flight and accommodation details, ticket or voucher numbers, baggage, seat and meal preferences, loyalty programme information and travelling companions;",
            "travel-document and regulatory data, including passport or identity-document details, visa information, citizenship, place of birth and other data required by a Supplier or public authority;",
            "payment and transaction data, including payment status, amount, currency, billing details, refund information, masked card details and transaction or provider references;",
            "communications and support data, including enquiries, emails, calls, messages, complaints, feedback and documents submitted to customer service;",
            "technical and usage data, including IP address, device and browser information, operating system, identifiers, log records, requested pages, referral source, date and time of access, approximate location and cookie data;",
            "marketing and preference data, including communication choices, campaign interactions and survey responses; and",
            "corporate travel data, including employer or organisation, role, business contact details, cost centre, travel policy and approval information where relevant.",
          ],
        },
        {
          type: "text",
          text: "The exact data required is indicated in the Website interface, booking process or communication with the Company. If required data is not provided, the Company may be unable to create an account, process a booking, issue travel documents or provide the requested Service.",
        },
      ],
    },
    {
      title: "Sources of Personal Data",
      blocks: [
        { type: "text", text: "The Company may obtain personal data:" },
        {
          type: "list",
          items: [
            "directly from the User through the Website, booking forms, account area, telephone, email, messaging services or in-person communications;",
            "from a customer, employer, travel arranger, family member or another person booking or enquiring on behalf of the User;",
            "from Suppliers, global distribution systems (GDS), reservation platforms, NDC or API connections, payment providers and other service partners;",
            "automatically from the User's device through server logs, cookies, pixels and similar technologies; and",
            "from competent authorities or publicly available sources where permitted by law and reasonably necessary.",
          ],
        },
        {
          type: "text",
          text: "A person who provides another individual's data must be authorised to do so, must ensure that the data is accurate and must make this Policy and all relevant booking conditions available to that individual.",
        },
      ],
    },
    {
      title: "Purposes and Legal Bases for Processing",
      blocks: [
        {
          type: "text",
          text: "The Company processes personal data only where an appropriate legal basis applies. Depending on the circumstances, processing may be necessary to perform a contract or take steps requested before entering into a contract, comply with a legal obligation, pursue a legitimate interest that is not overridden by the individual's rights, protect vital interests, perform a task authorised by law, or act on the User's consent.",
        },
        { type: "text", text: "Personal data may be processed for the following purposes:" },
        {
          type: "list",
          items: [
            "creating and administering an account, authenticating the User and maintaining account security;",
            "searching, quoting, booking, issuing, changing, cancelling and refunding travel Services;",
            "communicating with Users, sending confirmations and travel updates, and providing customer support;",
            "processing payments, refunds, chargebacks, reconciliation and fraud-prevention checks;",
            "providing DMC services in Turkmenistan, including accommodation, transfers, excursions, guiding, invitation support and local coordination;",
            "providing and administering corporate travel Services, reports, approvals and traveller support;",
            "meeting legal, tax, accounting, aviation, immigration, sanctions, security and regulatory requirements;",
            "protecting the Website, Users, the Company and Suppliers against fraud, abuse, cyber incidents and unlawful activity;",
            "analysing, maintaining and improving the Website, Services and customer experience;",
            "establishing, exercising or defending legal claims and resolving disputes; and",
            "sending marketing communications where permitted by law and consistent with the User's preferences.",
          ],
        },
        {
          type: "text",
          text: "Where consent is the legal basis, the User may withdraw it at any time. Withdrawal does not affect the lawfulness of processing carried out before withdrawal and does not prevent processing based on another lawful ground.",
        },
      ],
    },
    {
      title: "Other Passengers and Minors",
      blocks: [
        {
          type: "text",
          text: "A User may provide personal data about another Passenger or Traveller only where the User is authorised to do so. The User must inform that person about the processing, provide access to this Policy and accurately communicate any request or choice made on their behalf.",
        },
        {
          type: "text",
          text: "Travel bookings may require personal data relating to children. Such data is processed only to arrange and provide the requested Services, meet legal or Supplier requirements, protect the child's interests and communicate with the responsible adult.",
        },
        {
          type: "text",
          text: "The Website is not intended for children to create accounts or place orders independently. A parent, guardian or other authorised adult must provide a minor's data and any consent required by applicable law.",
        },
      ],
    },
    {
      title: "Payments and Payment Providers",
      blocks: [
        {
          type: "text",
          text: "Payments may be processed by independent banks, acquirers and payment providers, including Stripe and PayPal where available. These providers process certain personal data under their own privacy notices and security requirements.",
        },
        {
          type: "text",
          text: "When card details are entered directly into a payment provider's secure interface, the Company generally does not receive or store the complete card number or card security code (CVV/CVC). The Company may receive a payment token, masked card details, transaction reference, payer details, status, amount, currency and information needed for reconciliation, refunds, fraud prevention and support.",
        },
        {
          type: "text",
          text: "Payment providers, issuing banks or card networks may conduct identity, risk, sanctions or fraud checks and may decline, delay or reverse a transaction under their own rules. Users should review the relevant provider's privacy notice before submitting payment data.",
        },
      ],
    },
    {
      title: "Cookies and Similar Technologies",
      blocks: [
        {
          type: "text",
          text: "The Website may use cookies, pixels, local storage and similar technologies to operate, secure, personalise and measure the Website. Cookies may be session cookies, which expire when the browser closes, or persistent cookies, which remain for a defined period.",
        },
        { type: "text", text: "Depending on the Website configuration, these technologies may be used for:" },
        {
          type: "list",
          items: [
            "strictly necessary functions, such as navigation, authentication, security and booking continuity;",
            "functional preferences, such as language, region and saved settings;",
            "analytics and performance measurement, including understanding how pages and features are used; and",
            "advertising or campaign measurement, where such technologies are enabled and permitted.",
          ],
        },
        {
          type: "text",
          text: "Where required by law, non-essential cookies are used only after the User makes a choice through the available consent mechanism. The User can change cookie settings in the Website controls, where provided, or in the browser. Blocking some cookies may affect Website functionality.",
        },
      ],
    },
    {
      title: "Recipients of Personal Data",
      blocks: [
        {
          type: "text",
          text: "The Company may disclose personal data only to the extent necessary for the purposes described in this Policy, including to:",
        },
        {
          type: "list",
          items: [
            "airlines, hotels, carriers, transfer providers, guides, tour operators, insurers and other Suppliers;",
            "global distribution systems, reservation platforms, NDC or API providers and technology partners;",
            "banks, payment providers, card networks, fraud-prevention and verification providers;",
            "hosting, cloud, communications, analytics, customer-support and professional service providers acting under appropriate obligations;",
            "the User's employer, corporate travel manager or authorised travel arranger where the Service is provided under a corporate arrangement;",
            "affiliates or business partners where necessary for a requested Service and permitted by law; and",
            "courts, regulators, law-enforcement bodies, border, immigration, customs, tax and other competent authorities where disclosure is required or lawfully requested.",
          ],
        },
        {
          type: "text",
          text: "Independent recipients determine their own processing where they act as separate controllers. Service providers acting on the Company's instructions are required to process data only for agreed purposes and to apply appropriate safeguards.",
        },
        { type: "text", text: "The Company does not sell or rent Users' personal data." },
      ],
    },
    {
      title: "International Transfers and Data Storage",
      blocks: [
        {
          type: "text",
          text: "Travel Services are international by nature. Personal data may therefore be transferred to and processed in countries where the relevant Supplier, payment provider, reservation platform, service partner or public authority is located, including the country of departure, transit or destination.",
        },
        {
          type: "text",
          text: "The laws and level of personal-data protection in a recipient country may differ from those in the User's country. Where applicable law requires a transfer mechanism or other safeguard, the Company uses an appropriate lawful basis, contractual protection, consent or another permitted measure.",
        },
        {
          type: "text",
          text: "The Company organises the collection, systematisation, accumulation, storage, clarification and use of personal data in accordance with applicable Turkmenistan requirements, including any applicable rules concerning databases or storage in Turkmenistan. Where service delivery requires a cross-border transfer, only the data reasonably necessary for that purpose is transferred.",
        },
      ],
    },
    {
      title: "Special Categories of Personal Data",
      blocks: [
        {
          type: "text",
          text: "The Company does not intentionally request information revealing racial or ethnic origin, political opinions, religious or philosophical beliefs, trade-union membership, genetic or biometric identifiers, health information or information about a person's sex life or sexual orientation unless such information is genuinely necessary for a requested Service or required by law.",
        },
        {
          type: "text",
          text: "Health, accessibility, dietary, mobility or other sensitive information may be needed to request special assistance, suitable accommodation, meals, insurance support or another travel arrangement. The Company processes such data only to the extent necessary and on a lawful basis, which may include the User's explicit consent, protection of vital interests or compliance with legal obligations.",
        },
        { type: "text", text: "Users should not provide sensitive information that is not necessary for the requested Service." },
      ],
    },
    {
      title: "Retention Periods",
      blocks: [
        {
          type: "text",
          text: "The Company retains personal data only for as long as reasonably necessary for the purpose for which it was collected, including the provision of Services, support, accounting, tax, audit, fraud prevention, dispute resolution and compliance with legal or Supplier requirements.",
        },
        {
          type: "text",
          text: "The applicable retention period depends on the category of data, the nature and duration of the relationship, contractual and statutory limitation periods, legal retention duties, security requirements, the existence of a complaint or dispute and any valid request by the User.",
        },
        {
          type: "text",
          text: "When personal data is no longer required, it is deleted, anonymised or isolated from ordinary use, unless continued storage is required or permitted by law. Backup copies may remain for a limited period and are protected from routine access.",
        },
      ],
    },
    {
      title: "Data Security",
      blocks: [
        {
          type: "text",
          text: "The Company applies reasonable organisational and technical measures designed to protect personal data against accidental or unlawful destruction, loss, alteration, disclosure, access or misuse. Measures may include access controls, authentication, encryption in transit where appropriate, secure payment interfaces, logging, backups, staff confidentiality duties and service-provider controls.",
        },
        {
          type: "text",
          text: "No method of transmission or storage is completely secure. Users should protect their account credentials and verification codes, use trusted devices and networks, and notify the Company promptly if they suspect unauthorised access or misuse.",
        },
        {
          type: "text",
          text: "If a personal-data incident occurs, the Company investigates, mitigates and documents the incident and notifies affected individuals or competent authorities where required by applicable law.",
        },
      ],
    },
    {
      title: "User Rights",
      blocks: [
        { type: "text", text: "Subject to applicable law and any permitted limitations, a User may have the right to:" },
        {
          type: "list",
          items: [
            "obtain information about whether and how their personal data is processed;",
            "request access to or a copy of their personal data;",
            "request correction or completion of inaccurate or incomplete data;",
            "request deletion, destruction, anonymisation or restriction of processing;",
            "object to processing based on certain grounds, including direct marketing;",
            "withdraw consent where processing is based on consent;",
            "receive certain data in a portable format where the law provides this right;",
            "request human review of a decision based solely on automated processing where applicable; and",
            "lodge a complaint with a competent data-protection or supervisory authority.",
          ],
        },
        {
          type: "text",
          text: "A request may be submitted using the contact details in Section 19. To protect personal data, the Company may ask for information reasonably necessary to verify identity and authority. The Company responds within the period required by applicable law and may refuse or limit a request where a lawful exception applies.",
        },
        {
          type: "text",
          text: "Some data cannot be deleted immediately where it remains necessary to complete a booking, comply with law, keep mandatory records, prevent fraud, resolve a dispute or establish, exercise or defend legal claims.",
        },
      ],
    },
    {
      title: "Marketing Communications",
      blocks: [
        {
          type: "text",
          text: "The Company may send news, offers and information about FlyAshgabat or selected partner Services where the User has consented or where another lawful basis permits such communication.",
        },
        {
          type: "text",
          text: "The User may opt out at any time by using the unsubscribe method in the message or contacting the Company. Opting out of marketing does not stop operational communications that are necessary for an account, booking, payment, security notice or customer-service request.",
        },
      ],
    },
    {
      title: "Automated Checks",
      blocks: [
        {
          type: "text",
          text: "The Website, payment providers or fraud-prevention partners may use automated rules or risk indicators to detect suspicious transactions, account misuse, duplicate bookings, sanctions concerns or security threats.",
        },
        {
          type: "text",
          text: "An automated check may result in a request for additional verification, a temporary delay or referral for manual review. Where applicable law provides rights in relation to a decision based solely on automated processing that has legal or similarly significant effects, the User may request human intervention, express their point of view and challenge the decision.",
        },
      ],
    },
    {
      title: "Third-Party Websites and Services",
      blocks: [
        {
          type: "text",
          text: "The Website may contain links, embedded tools or redirects to websites and services operated by Suppliers, payment providers, social networks or other third parties. Their privacy practices are outside the Company's direct control.",
        },
        {
          type: "text",
          text: "Users should review the privacy notice and terms of each third-party service before providing personal data. The Company is not responsible for independent processing performed by a third party, except to the extent responsibility cannot be excluded under applicable law.",
        },
      ],
    },
    {
      title: "Changes to this Policy",
      blocks: [
        {
          type: "text",
          text: "The Company may update this Policy from time to time to reflect changes in the Website, Services, processing activities, legal requirements or business practices. The current version is published at https://flyashgabat.com/privacy-policy-info and shows its effective date.",
        },
        {
          type: "text",
          text: "Where a change materially affects Users' rights or the way personal data is processed, the Company will provide additional notice or obtain consent where required by law. Continued use of the Website after an update does not constitute consent where applicable law requires a separate affirmative action.",
        },
      ],
    },
    {
      title: "Contact Details",
      blocks: [
        {
          type: "text",
          text: "For questions about privacy, personal-data processing or the exercise of rights, please contact the Company using the details below:",
        },
        {
          type: "table",
          rows: [
            { label: "Data controller", value: "Individual Enterprise \"Jahankeshde Hyzmat\"" },
            { label: "English name", value: "Jahankeshde Hyzmat P.E." },
            { label: "Registered address", value: "5A Gorkut-Ata Street, Mary, Turkmenistan" },
            { label: "Business address", value: "5A Gorkut-Ata Street, Mary, Turkmenistan" },
            { label: "Landline", value: "+993 522 4 55 44", href: "tel:+99352245544" },
            { label: "Mobile", value: "+993 61 826345", href: "tel:+99361826345" },
            { label: "Email", value: "info@flyashgabat.com" },
            { label: "Website", value: "https://www.flyashgabat.com" },
          ],
        },
      ],
    },
  ],
};

const ru = {
  title: "Политика конфиденциальности",
  subtitle: "Обработка и защита персональных данных на www.flyashgabat.com",
  meta: [
    { label: "Оператор", value: "Индивидуальное предприятие «Jahankeshde Hyzmat» (Jahankeshde Hyzmat P.E.)" },
    { label: "Сайт", value: "https://www.flyashgabat.com" },
    { label: "Версия", value: "1.0 — проект для юридической проверки" },
    { label: "Дата вступления в силу", value: "20.08.2026" },
  ],
  sections: [
    {
      title: "Область применения и оператор данных",
      blocks: [
        {
          type: "text",
          text: "Настоящая Политика конфиденциальности (далее — «Политика») описывает, как Индивидуальное предприятие «Jahankeshde Hyzmat», зарегистрированное по законодательству Туркменистана (далее — «Компания», «Оператор» или «Jahankeshde Hyzmat P.E.»), собирает, использует, хранит, передаёт и защищает персональные данные при работе сайта www.flyashgabat.com и связанных с ним сервисов под брендом FlyAshgabat.",
        },
        {
          type: "text",
          text: "Политика применяется к посетителям Сайта, зарегистрированным пользователям, заказчикам, пассажирам, туристам, получателям корпоративных туристических услуг, представителям партнёров и иным физическим лицам, чьи данные обрабатываются в связи с запросом, бронированием или оказанием услуги.",
        },
        {
          type: "text",
          text: "Юридический адрес и адрес местонахождения Компании: Туркменистан, г. Мары, ул. Горкут-Ата, 5A (Gorkut-Ata 5A, Mary city, Turkmenistan). Контактные данные приведены в разделе 19 настоящей Политики.",
        },
        {
          type: "text",
          text: "Основным применимым законодательством является законодательство Туркменистана, включая Закон Туркменистана «Об информации о личной жизни и её защите». Если конкретная обработка подпадает под обязательные нормы другой юрисдикции, Компания также соблюдает такие нормы в применимом объёме, в том числе Регламент (ЕС) 2016/679 (GDPR) и Закон Турецкой Республики № 6698 «О защите персональных данных» (KVKK).",
        },
        {
          type: "text",
          text: "Использование Сайта означает ознакомление с Политикой, но само по себе не заменяет отдельное согласие там, где такое согласие требуется законом. Если Пользователь не согласен с обработкой обязательных для оказания услуги данных, он должен воздержаться от оформления соответствующего Заказа.",
        },
      ],
    },
    {
      title: "Основные понятия и принципы",
      blocks: [
        {
          type: "text",
          text: "Персональные данные — любая информация, относящаяся к определённому или определяемому физическому лицу; в терминологии законодательства Туркменистана — личные сведения.",
        },
        {
          type: "text",
          text: "Обработка — любое действие с персональными данными, включая сбор, запись, систематизацию, хранение, уточнение, использование, передачу, предоставление доступа, блокирование, обезличивание и уничтожение.",
        },
        {
          type: "text",
          text: "Пользователь — физическое лицо, которое посещает Сайт, создаёт учётную запись, направляет запрос, оформляет Заказ либо является пассажиром или туристом по Заказу.",
        },
        {
          type: "text",
          text: "Поставщик — авиакомпания, гостиница, перевозчик, система бронирования, туроператор, страховая компания, платёжная организация, трансферная компания, экскурсионная организация или другой независимый исполнитель.",
        },
        {
          type: "text",
          text: "Cookies — небольшие файлы и аналогичные технологии, сохраняемые на устройстве или считываемые с него для работы Сайта, запоминания настроек, аналитики и, при наличии согласия, рекламы.",
        },
        {
          type: "text",
          text: "Компания руководствуется принципами законности, добросовестности и прозрачности, ограничения обработки заранее определёнными целями, минимизации объёма данных, точности, ограничения сроков хранения, конфиденциальности и безопасности.",
        },
      ],
    },
    {
      title: "Какие данные обрабатывает Компания",
      blocks: [
        {
          type: "text",
          text: "Объём данных зависит от используемой функции, состава Заказа, требований Поставщика и закона. Компания может обрабатывать следующие категории:",
        },
        {
          type: "list",
          items: [
            "идентификационные и контактные данные: имя, фамилия, отчество, дата рождения, номер телефона, адрес электронной почты, адрес проживания или выставления счёта, предпочитаемый язык;",
            "данные учётной записи: идентификатор пользователя, сведения о подтверждении телефона или электронной почты, настройки и история входов, если личный кабинет доступен;",
            "данные пассажира или туриста: гражданство, пол в соответствии с проездным документом, данные паспорта или иного документа, страна выдачи, даты выдачи и окончания срока действия, маршрут, даты поездки, номер программы лояльности, выбранные услуги и специальные запросы;",
            "данные Заказа и поездки: направления, рейсы, гостиницы, трансферы, экскурсии, состав туристической программы, тарифы, ваучеры, билеты, изменения, отмены, возвраты и сведения о сопровождающих лицах;",
            "платёжные и расчётные данные: сумма, валюта, статус платежа, идентификатор транзакции, способ оплаты, ограниченные сведения о платёжном инструменте и данные, необходимые для выставления счёта, возврата и предотвращения мошенничества;",
            "данные обращений: сообщения, электронные письма, записи запросов в службу поддержки, документы и сведения, которые Пользователь добровольно предоставляет для решения вопроса;",
            "технические данные: IP-адрес, тип и версия браузера, устройство, операционная система, часовой пояс, язык, приблизительное местоположение, журналы событий, дата и время посещения, просмотренные страницы и источник перехода;",
            "данные о предпочтениях: выбранный язык, настройки cookies, согласия, отказ от рассылки, интерес к направлениям и предложениям;",
            "данные представителей корпоративных клиентов и партнёров: должность, организация, служебные контакты, полномочия и деловая переписка.",
          ],
        },
        {
          type: "text",
          text: "Обязательные поля обозначаются в интерфейсе или следуют из характера услуги. Без предоставления данных, необходимых для идентификации, бронирования, оплаты или выполнения требований Поставщика, Компания может быть не в состоянии оформить или исполнить Заказ.",
        },
      ],
    },
    {
      title: "Источники получения данных",
      blocks: [
        {
          type: "text",
          text: "Компания получает данные непосредственно от Пользователя при посещении Сайта, регистрации, заполнении формы, оформлении Заказа, оплате, подписке, обращении в поддержку или участии в опросе.",
        },
        {
          type: "text",
          text: "Если Заказ оформляется для другого лица, данные могут быть получены от заказчика, работодателя, корпоративного клиента, родственника или иного уполномоченного лица. Такое лицо обязано иметь законные основания для передачи данных и сообщить пассажиру или туристу о настоящей Политике.",
        },
        {
          type: "text",
          text: "Компания также может получать данные от Поставщиков, глобальных и региональных систем бронирования, API-партнёров, платёжных провайдеров, банков, антифрод-сервисов, рекламных и аналитических партнёров, а также из законных общедоступных источников.",
        },
        {
          type: "text",
          text: "Технические данные и сведения об использовании Сайта могут собираться автоматически с помощью серверных журналов, cookies, локального хранилища, пикселей и аналогичных технологий.",
        },
      ],
    },
    {
      title: "Цели и правовые основания обработки",
      blocks: [
        {
          type: "text",
          text: "Компания обрабатывает персональные данные только для заранее определённых и законных целей, включая:",
        },
        {
          type: "list",
          items: [
            "создание и обслуживание учётной записи, идентификацию и аутентификацию Пользователя;",
            "поиск, расчёт, бронирование, оформление, оплату, подтверждение, изменение, отмену и возврат авиабилетов, гостиниц, трансферов, туристических программ и иных услуг;",
            "оказание DMC-услуг в Туркменистане, организацию маршрутов, экскурсий, сопровождения, приглашений и иных согласованных элементов поездки;",
            "связь с Пользователем, направление билетов, ваучеров, уведомлений об изменениях и ответы службы поддержки;",
            "проведение платежей, бухгалтерский и налоговый учёт, возвраты, сверку и урегулирование споров;",
            "информационную безопасность, предотвращение мошенничества, злоупотреблений, фиктивных бронирований и несанкционированного доступа;",
            "выполнение требований законодательства, Поставщиков, перевозчиков, миграционных, таможенных, правоохранительных и иных компетентных органов;",
            "улучшение работы Сайта, контроль качества, статистику и аналитику, по возможности с использованием обезличенных данных;",
            "направление маркетинговых сообщений и персонализацию рекламы только при наличии требуемого согласия или иного законного основания;",
            "установление, осуществление и защиту законных требований Компании и Пользователей.",
          ],
        },
        {
          type: "text",
          text: "В зависимости от применимого права обработка основывается на согласии субъекта, необходимости заключить или исполнить договор, выполнении юридической обязанности, защите жизненно важных интересов, а также законных интересах Компании или третьего лица, если такие интересы не преобладают над правами и свободами субъекта.",
        },
        {
          type: "text",
          text: "Если обработка основана на согласии, Пользователь вправе отозвать его доступным способом. Отзыв не влияет на законность обработки до отзыва и не прекращает обработку, которая требуется для исполнения неисполненного обязательства или по закону.",
        },
      ],
    },
    {
      title: "Данные других пассажиров и несовершеннолетних",
      blocks: [
        {
          type: "text",
          text: "Оформляя Заказ для другого лица, Пользователь подтверждает, что уполномочен передать его данные, оформить необходимые согласия и действовать в пределах предоставленных полномочий. Компания вправе запросить подтверждение таких полномочий.",
        },
        {
          type: "text",
          text: "Самостоятельно создавать Заказ и принимать условия Сайта может лицо, достигшее 18 лет. Данные несовершеннолетнего пассажира или туриста обрабатываются только в объёме, необходимом для поездки, на основании сведений и полномочий родителя, законного представителя или иного правомерно действующего заказчика.",
        },
        {
          type: "text",
          text: "Компания не предназначает Сайт для самостоятельного использования детьми и не стремится собирать их данные для маркетинга или создания профиля. Если Компания узнает, что данные ребёнка получены без надлежащего основания, она примет разумные меры для их удаления или урегулирования согласия.",
        },
      ],
    },
    {
      title: "Платежи и платёжные провайдеры",
      blocks: [
        {
          type: "text",
          text: "Оплата может обрабатываться банками и независимыми платёжными провайдерами, включая Stripe и PayPal, если соответствующий способ доступен на Сайте. Такой провайдер обрабатывает платёжные данные по собственным условиям и политике конфиденциальности.",
        },
        {
          type: "text",
          text: "Как правило, Компания не получает и не хранит полный номер банковской карты и код безопасности CVV/CVC, если эти сведения вводятся в защищённом интерфейсе платёжного провайдера. Компания может получать статус платежа, идентификатор операции, имя плательщика, платёжный токен, последние цифры карты, срок действия и иные ограниченные данные, необходимые для учёта, возврата и антифрод-проверки.",
        },
        {
          type: "text",
          text: "Платёжный провайдер, банк или эмитент карты может запросить дополнительные сведения и провести собственную проверку личности или операции. Компания не контролирует самостоятельную обработку данных такими организациями.",
        },
      ],
    },
    {
      title: "Cookies и аналогичные технологии",
      blocks: [
        {
          type: "text",
          text: "Сайт может использовать сессионные и постоянные cookies, локальное хранилище, пиксели и аналогичные технологии. Они помогают поддерживать сессию, сохранять настройки, обеспечивать безопасность, измерять работу Сайта и оценивать эффективность коммуникаций.",
        },
        { type: "text", text: "Cookies могут относиться к следующим категориям:" },
        {
          type: "list",
          items: [
            "строго необходимые — обеспечивают работу, безопасность, авторизацию, корзину и оформление Заказа;",
            "функциональные — запоминают язык, регион и другие выбранные настройки;",
            "аналитические — помогают понять использование Сайта и устранить ошибки;",
            "рекламные — используются для измерения и персонализации рекламы при наличии требуемого согласия.",
          ],
        },
        {
          type: "text",
          text: "Необязательные cookies устанавливаются только в соответствии с выбором Пользователя и требованиями применимого законодательства. Пользователь может изменить решение в настройках cookies Сайта или браузера. Блокирование строго необходимых cookies может ограничить функциональность бронирования и оплаты.",
        },
        {
          type: "text",
          text: "Перечень фактически используемых технологий, их поставщиков, назначение и срок действия должен отображаться в панели управления cookies и обновляться при изменении технической конфигурации Сайта.",
        },
      ],
    },
    {
      title: "Кому могут передаваться данные",
      blocks: [
        {
          type: "text",
          text: "Для исполнения Заказа и работы Сайта Компания может предоставлять необходимые данные следующим категориям получателей:",
        },
        {
          type: "list",
          items: [
            "авиакомпаниям, гостиницам, перевозчикам, туроператорам, DMC-партнёрам, гидам, трансферным и экскурсионным компаниям, страховщикам и другим Поставщикам;",
            "глобальным и региональным системам бронирования, NDC/GDS-провайдерам, API-поставщикам, консолидаторам и агентам по оформлению;",
            "банкам, платёжным системам, Stripe, PayPal, эмитентам карт и организациям по предотвращению мошенничества;",
            "поставщикам хостинга, облачной инфраструктуры, электронной почты, CRM, связи, аналитики, технической поддержки и информационной безопасности;",
            "визовым, консульским, миграционным, таможенным, аэропортовым и иным компетентным органам, когда это необходимо для услуги или требуется законом;",
            "аудиторам, юристам, бухгалтерам, страховщикам и иным профессиональным консультантам, связанным обязательствами конфиденциальности;",
            "корпоративному заказчику, оплатившему поездку, в пределах, необходимых для организации поездки, отчётности и соблюдения корпоративной политики;",
            "правоохранительным, судебным, налоговым и иным государственным органам при наличии надлежащего законного запроса или обязанности.",
          ],
        },
        {
          type: "text",
          text: "Компания не продаёт и не сдаёт в аренду персональные данные. Передача ограничивается данными, необходимыми для конкретной цели, и осуществляется при наличии согласия, договора, требования закона или иного надлежащего основания.",
        },
        {
          type: "text",
          text: "Когда это требуется законом, Компания уведомляет субъекта о предоставлении его данных третьему лицу в установленный срок, за исключением предусмотренных законом случаев.",
        },
      ],
    },
    {
      title: "Международная передача и место хранения",
      blocks: [
        {
          type: "text",
          text: "Туристические услуги по своей природе могут требовать передачи данных за пределы страны проживания Пользователя и за пределы Туркменистана — в частности, в страны отправления, транзита и назначения, а также в страны расположения Поставщиков, систем бронирования и платёжных провайдеров.",
        },
        {
          type: "text",
          text: "Компания организует накопление и хранение базы персональных данных на территории Туркменистана в объёме, требуемом законодательством Туркменистана, и принимает меры, чтобы трансграничная передача осуществлялась только при наличии предусмотренных законом условий.",
        },
        {
          type: "text",
          text: "В зависимости от применимого права такими условиями могут быть надлежаще оформленное согласие, необходимость исполнения договора в интересах Пользователя, международный договор, решение об адекватности, стандартные договорные условия, договорные гарантии или иное разрешённое законом основание.",
        },
        {
          type: "text",
          text: "Защита данных в стране получателя может отличаться от защиты в стране проживания Пользователя. При выборе Поставщика и способа передачи Компания учитывает характер данных, цель передачи, обязательные требования и доступные меры безопасности.",
        },
      ],
    },
    {
      title: "Специальные категории данных",
      blocks: [
        {
          type: "text",
          text: "Компания не запрашивает сведения о расовом или этническом происхождении, политических взглядах, религиозных или философских убеждениях, членстве в профсоюзах, интимной жизни, генетические или биометрические данные для обычного использования Сайта.",
        },
        {
          type: "text",
          text: "Некоторые добровольные запросы — например, сведения о состоянии здоровья, ограниченной мобильности, аллергии, специальном питании или медицинском оборудовании — могут относиться к специальным категориям данных. Компания обрабатывает их только когда это необходимо для заказанной услуги и имеется явное согласие либо другое основание, прямо предусмотренное законом.",
        },
        {
          type: "text",
          text: "Такие данные передаются только тем Поставщикам, которым они необходимы для выполнения запроса, и хранятся не дольше, чем требуется для соответствующей цели или по закону.",
        },
      ],
    },
    {
      title: "Сроки хранения",
      blocks: [
        {
          type: "text",
          text: "Компания хранит персональные данные не дольше, чем это необходимо для целей, указанных в настоящей Политике, если более длительный срок не требуется законодательством, договором, бухгалтерским или налоговым учётом, урегулированием спора либо защитой законных требований.",
        },
        {
          type: "text",
          text: "Критериями определения срока являются продолжительность отношений с Пользователем, статус и история Заказа, сроки возврата и претензий, обязательные сроки хранения финансовых и туристических документов, требования Поставщиков, сроки исковой давности и риски безопасности.",
        },
        {
          type: "text",
          text: "Данные учётной записи хранятся, пока она активна, и далее в течение необходимого периода для закрытия обязательств и защиты от злоупотреблений. Маркетинговые данные хранятся до отзыва согласия или утраты цели. Сроки cookies указываются в панели управления cookies.",
        },
        {
          type: "text",
          text: "После достижения цели и истечения обязательных сроков данные уничтожаются, блокируются или обезличиваются безопасным способом, если дальнейшее хранение не имеет законного основания.",
        },
      ],
    },
    {
      title: "Безопасность данных",
      blocks: [
        {
          type: "text",
          text: "Компания применяет разумные и соразмерные правовые, организационные и технические меры, направленные на предотвращение незаконного доступа, утраты, изменения, раскрытия или уничтожения данных.",
        },
        {
          type: "text",
          text: "Меры могут включать разграничение доступа по служебной необходимости, аутентификацию, защищённую передачу данных, журналирование, резервное копирование, управление уязвимостями, требования конфиденциальности к сотрудникам и оценку поставщиков.",
        },
        {
          type: "text",
          text: "Ни один способ хранения или передачи через Интернет не обеспечивает абсолютную безопасность. Пользователь также обязан защищать данные своей учётной записи, использовать надёжные средства доступа и незамедлительно сообщать о подозрительной активности.",
        },
        {
          type: "text",
          text: "При выявлении нарушения безопасности Компания принимает меры для ограничения последствий, восстановления защищённости и уведомления субъектов или компетентных органов, если и в сроки, когда это требуется применимым законодательством.",
        },
      ],
    },
    {
      title: "Права Пользователя",
      blocks: [
        { type: "text", text: "В пределах применимого законодательства Пользователь вправе:" },
        {
          type: "list",
          items: [
            "узнать, обрабатывает ли Компания его данные, и получить сведения о целях, источниках, способах обработки, категориях, получателях и сроках хранения;",
            "получить доступ к своим данным и копию доступной информации;",
            "потребовать уточнения или исправления неполных, устаревших или недостоверных данных;",
            "потребовать блокирования, ограничения обработки или уничтожения данных в предусмотренных законом случаях;",
            "отозвать ранее данное согласие и отказаться от маркетинговых сообщений;",
            "возразить против обработки, основанной на законном интересе, если такое право предоставлено применимым законодательством;",
            "получить данные в переносимом формате, если это право применимо и технически осуществимо;",
            "не подвергаться решению, основанному исключительно на автоматизированной обработке и имеющему юридические или аналогично существенные последствия, кроме разрешённых законом случаев;",
            "обратиться в компетентный государственный орган или суд для защиты своих прав.",
          ],
        },
        {
          type: "text",
          text: "Для осуществления права Пользователь направляет запрос на info@flyashgabat.com либо по почтовому адресу Компании. В запросе следует указать имя, контактные данные, номер Заказа при наличии, суть требования и сведения, позволяющие идентифицировать данные.",
        },
        {
          type: "text",
          text: "Для защиты конфиденциальности Компания может запросить разумное подтверждение личности и полномочий. Ответ предоставляется без неоправданной задержки и в срок, установленный применимым законодательством. Право может быть ограничено, если исполнение запроса нарушит закон, права других лиц, требования хранения или неисполненные обязательства.",
        },
      ],
    },
    {
      title: "Маркетинговые сообщения",
      blocks: [
        {
          type: "text",
          text: "Компания направляет рекламные и информационные предложения по электронной почте, телефону, SMS или мессенджеру только при наличии предварительного согласия или другого допустимого законом основания.",
        },
        {
          type: "text",
          text: "Отказаться от маркетинга можно по ссылке в сообщении, через доступные настройки либо по адресу info@flyashgabat.com. Отказ не прекращает сервисные сообщения, необходимые для действующего Заказа, безопасности, оплаты, изменения расписания или исполнения юридической обязанности.",
        },
        { type: "text", text: "Компания не использует специальные категории данных для рекламного профилирования." },
      ],
    },
    {
      title: "Автоматизированные проверки",
      blocks: [
        {
          type: "text",
          text: "Для безопасности и предотвращения мошенничества Сайт, платёжные провайдеры и Поставщики могут автоматически анализировать технические параметры, признаки платёжного риска, историю действий и соответствие данных Заказа.",
        },
        {
          type: "text",
          text: "Такая проверка может временно приостановить оформление или направить Заказ на дополнительную проверку. Если решение может иметь существенные последствия для Пользователя и этого требует применимое право, Компания обеспечивает возможность обращения к сотруднику и представления пояснений.",
        },
      ],
    },
    {
      title: "Сторонние сайты и сервисы",
      blocks: [
        {
          type: "text",
          text: "Сайт может содержать ссылки на сайты авиакомпаний, гостиниц, платёжных провайдеров, государственных органов и других третьих лиц. После перехода обработка данных регулируется их собственными документами, если Компания не определяет цели и средства такой обработки совместно с ними.",
        },
        {
          type: "text",
          text: "Компания рекомендует ознакомиться с политикой конфиденциальности соответствующего третьего лица до передачи ему данных.",
        },
      ],
    },
    {
      title: "Изменение Политики",
      blocks: [
        {
          type: "text",
          text: "Компания вправе периодически обновлять Политику с учётом изменений Сайта, состава услуг, поставщиков, технологий и законодательства. Действующая редакция публикуется по адресу https://flyashgabat.com/privacy-policy-info с указанием даты вступления в силу.",
        },
        {
          type: "text",
          text: "Если изменения существенно влияют на права Пользователя или цели обработки, Компания размещает заметное уведомление на Сайте и, когда это требуется, запрашивает новое согласие.",
        },
        {
          type: "text",
          text: "Продолжение использования Сайта после обновления означает ознакомление с новой редакцией, но не считается согласием на обработку, для которой закон требует отдельного волеизъявления.",
        },
      ],
    },
    {
      title: "Контакты",
      blocks: [
        {
          type: "text",
          text: "По вопросам конфиденциальности, обработки данных и осуществления прав можно связаться с Компанией по следующим реквизитам:",
        },
        {
          type: "table",
          rows: [
            { label: "Оператор", value: "Индивидуальное предприятие «Jahankeshde Hyzmat»" },
            { label: "Английское наименование", value: "Jahankeshde Hyzmat P.E." },
            { label: "Юридический адрес", value: "Туркменистан, г. Мары, ул. Горкут-Ата, 5A" },
            { label: "Адрес местонахождения", value: "Туркменистан, г. Мары, ул. Горкут-Ата, 5A" },
            { label: "Телефон (городской)", value: "+993 522 4 55 44", href: "tel:+99352245544" },
            { label: "Телефон (мобильный)", value: "+993 61 826345", href: "tel:+99361826345" },
            { label: "Электронная почта", value: "info@flyashgabat.com" },
            { label: "Веб-сайт", value: "https://www.flyashgabat.com" },
          ],
        },
      ],
    },
  ],
};

const tm = {
  title: "Gizlinlik syýasaty",
  subtitle: "www.flyashgabat.com saýtynda şahsy maglumatlary işlemek we goramak",
  meta: [
    { label: "Maglumatlaryň operatory", value: "Jahankeshde Hyzmat P.E. («Jahankeshde Hyzmat» hususy kärhanasy)" },
    { label: "Web-saýt", value: "https://www.flyashgabat.com" },
    { label: "Wersiýa", value: "1.0 — hukuk seljermesi üçin taslama" },
    { label: "Güýje girýän senesi", value: "20.08.2026" },
  ],
  sections: [
    {
      title: "Hereket ediş çägi we maglumatlaryň operatory",
      blocks: [
        {
          type: "text",
          text: "Şu Gizlinlik syýasaty («Syýasat») FlyAshgabat brendi bilen işleýän «Jahankeshde Hyzmat» hususy kärhanasynyň («Kompaniýa», «biz») www.flyashgabat.com saýty («Saýt») hem-de degişli syýahat, kabul ediji tarap (DMC) we korporatiw syýahat hyzmatlary bilen baglylykda şahsy maglumatlary nähili ýygnaýandygyny, ulanýandygyny, saklaýandygyny, açýandygyny we goraýandygyny düşündirýär.",
        },
        {
          type: "text",
          text: "Kompaniýa Türkmenistanyň kanunçylygyna laýyklykda döredilendir we şu Syýasatda beýan edilen işlemek boýunça maglumatlaryň operatory bolup durýar, işlemegiň maksatlaryny we serişdelerini başga bir tarap — meselem, awiakompaniýa, myhmanhana, töleg üpjün edijisi ýa-da döwlet edarasy — özbaşdak kesgitleýän halatlardan başga.",
        },
        {
          type: "text",
          text: "Şu Syýasat Saýtyň myhmanlaryna, hasaba alnan ulanyjylara, müşderilere, ýolagçylara, syýahatçylara, korporatiw wekillere we şahsy maglumatlary Kompaniýa berlen ýa-da Kompaniýa tarapyndan alnan beýleki şahslara degişlidir. Gizlinlik boýunça soraglar üçin habarlaşmak maglumatlary 19-njy bölümde görkezilendir.",
        },
        {
          type: "text",
          text: "Şu Syýasat aç-açan maglumat bermek üçin niýetlenendir. Saýtdan peýdalanmak ulanyjynyň şu Syýasat bilen tanyşmaga mümkinçiliginiň bolandygyny tassyklaýar; kanun belli bir işlemek üçin anyk we meýletin razylygy talap edýän halatynda ol razylygyň ýerini tutmaýar.",
        },
        {
          type: "text",
          text: "Esasy hukuk binýady — Türkmenistanyň kanunçylygy, şol sanda Türkmenistanyň «Şahsy durmuş hakynda maglumat we ony goramak hakynda» Kanuny. Belli bir işlemek olaryň çägine düşýän bolsa, Kompaniýa şeýle hem Ýewropa Bileleşiginiň 2016/679 belgili Düzgünnamasyny («GDPR») we Türkiýe Respublikasynyň şahsy maglumatlary goramak hakyndaky 6698 belgili Kanunyny («KVKK»), beýleki hökmany kadalar bilen bilelikde ulanýar.",
        },
      ],
    },
    {
      title: "Esasy düşünjeler we ýörelgeler",
      blocks: [
        {
          type: "text",
          text: "Şahsy maglumatlar — kesgitlenen ýa-da kesgitlenip bilinjek fiziki şahsa degişli islendik maglumat.",
        },
        {
          type: "text",
          text: "Işlemek — şahsy maglumatlar bilen amala aşyrylýan islendik hereket, şol sanda ýygnamak, ýazga geçirmek, tertipleşdirmek, saklamak, ulanmak, açmak, geçirmek, çäklendirmek we pozmak.",
        },
        {
          type: "text",
          text: "Ulanyjy — Saýtyň myhmany, hasabyň eýesi, müşderi, ýolagçy, syýahatçy, korporatiw wekil ýa-da Kompaniýanyň hyzmatlaryndan peýdalanýan beýleki şahs.",
        },
        {
          type: "text",
          text: "Üpjün ediji — hyzmata gatnaşýan awiakompaniýa, myhmanhana, gatnadyjy, bronlaşdyryş ulgamy, tur operatory, ätiýaçlandyryjy, töleg üpjün edijisi, transfer üpjün edijisi, ekskursiýa üpjün edijisi ýa-da beýleki garaşsyz üpjün ediji.",
        },
        {
          type: "text",
          text: "Kompaniýa şahsy maglumatlary kanuny, adalatly we aç-açan; anyk maksatlar üçin; diňe esasly zerur möçberde; degişli takyklyk, saklaýyş çäkleri we howpsuzlyk bilen hem-de hasabatlylygy üpjün edýän görnüşde işleýär.",
        },
      ],
    },
    {
      title: "Biz haýsy şahsy maglumatlary işleýäris",
      blocks: [
        {
          type: "text",
          text: "Ulanyjynyň FlyAshgabat bilen nähili gatnaşyk edýändigine we haýsy hyzmatlaryň soralýandygyna baglylykda Kompaniýa şahsy maglumatlaryň şu toparlaryny işläp biler:",
        },
        {
          type: "list",
          items: [
            "şahsyýet maglumatlary: doly ady, doglan senesi, jynsy, raýatlygy hem-de müşderiniň ýa-da hasabyň kesgitleýjileri;",
            "habarlaşmak maglumatlary: e-poçta salgysy, telefon belgisi, poçta salgysy, ýurt we saýlanan dil;",
            "hasap maglumatlary: giriş maglumatlary, tassyklaýyş kodlary, profil maglumatlary we saklanan sazlamalar;",
            "bron we syýahat maglumatlary: ugur, seneler, aeroportlar, uçuş we ýerleşdiriş maglumatlary, petegiň ýa-da wauçeriň belgileri, bagaž, orun we iýmit boýunça saýlawlar, wepalylyk maksatnamasynyň maglumatlary hem-de bile syýahat edýänler;",
            "syýahat resminamalary we kadalaşdyryjy maglumatlar: pasportyň ýa-da şahsyýetnamanyň maglumatlary, wiza maglumatlary, raýatlygy, doglan ýeri we üpjün ediji ýa-da döwlet edarasy tarapyndan talap edilýän beýleki maglumatlar;",
            "töleg we amal maglumatlary: tölegiň ýagdaýy, möçberi, pul birligi, hasap maglumatlary, pul gaýtarmak barada maglumat, kartanyň gizlenen maglumatlary hem-de amalyň ýa-da üpjün edijiniň salgylanmalary;",
            "habarlaşmak we goldaw maglumatlary: soraglar, e-poçta hatlary, jaňlar, habarlar, şikaýatlar, pikirler we müşderi hyzmatyna berlen resminamalar;",
            "tehniki we ulanyş maglumatlary: IP salgysy, enjam we brauzer barada maglumat, operasion ulgam, kesgitleýjiler, žurnal ýazgylary, soralan sahypalar, geçiş çeşmesi, girişiň senesi we wagty, takmyny ýerleşýän ýeri hem-de kuki maglumatlary;",
            "marketing we saýlaw maglumatlary: habarlaşmak boýunça saýlawlar, kampaniýalar bilen gatnaşyk we soragnamalara jogaplar; hem-de",
            "korporatiw syýahat maglumatlary: iş beriji ýa-da gurama, wezipe, işewürlik habarlaşmak maglumatlary, çykdajy merkezi, syýahat syýasaty we degişli halatynda tassyklamalar barada maglumat.",
          ],
        },
        {
          type: "text",
          text: "Talap edilýän anyk maglumatlar Saýtyň interfeýsinde, bronlaşdyrmak wagtynda ýa-da Kompaniýa bilen ýazyşmakda görkezilýär. Zerur maglumatlar berilmese, Kompaniýa hasap döredip, brony resmileşdirip, syýahat resminamalaryny berip ýa-da soralan hyzmaty hödürläp bilmezligi mümkin.",
        },
      ],
    },
    {
      title: "Şahsy maglumatlaryň çeşmeleri",
      blocks: [
        { type: "text", text: "Kompaniýa şahsy maglumatlary şulardan alyp biler:" },
        {
          type: "list",
          items: [
            "gönüden-göni Ulanyjydan — Saýt, bron formalary, şahsy hasap, telefon, e-poçta, habarlaşma hyzmatlary ýa-da şahsy gatnaşyk arkaly;",
            "Ulanyjynyň adyndan bron edýän ýa-da sorag berýän müşderiden, iş berijiden, syýahaty guraýjydan, maşgala agzasyndan ýa-da başga şahsdan;",
            "üpjün edijilerden, global paýlaýyş ulgamlaryndan (GDS), bronlaşdyryş platformalaryndan, NDC ýa-da API birikmelerinden, töleg üpjün edijilerinden we beýleki hyzmat hyzmatdaşlaryndan;",
            "Ulanyjynyň enjamyndan awtomatik usulda — server žurnallary, kukiler, pikseller we meňzeş tehnologiýalar arkaly; hem-de",
            "kanun rugsat berýän we esasly zerur bolan halatynda ygtyýarly edaralardan ýa-da köpçülige elýeterli çeşmelerden.",
          ],
        },
        {
          type: "text",
          text: "Başga bir şahsyň maglumatlaryny berýän adam muňa ygtyýarly bolmalydyr, maglumatlaryň dogrulygyny üpjün etmelidir hem-de şu Syýasaty we ähli degişli bron şertlerini şol şahsa elýeterli etmelidir.",
        },
      ],
    },
    {
      title: "Işlemegiň maksatlary we hukuk esaslary",
      blocks: [
        {
          type: "text",
          text: "Kompaniýa şahsy maglumatlary diňe degişli hukuk esasy bolan halatynda işleýär. Ýagdaýa baglylykda işlemek şertnamany ýerine ýetirmek ýa-da şertnama baglaşmazdan öň soralan hereketleri amala aşyrmak, kanuny borjy ýerine ýetirmek, şahsyň hukuklaryndan agdyklyk etmeýän kanuny bähbidi gorap saklamak, möhüm bähbitleri goramak, kanun tarapyndan ygtyýar berlen wezipäni ýerine ýetirmek ýa-da Ulanyjynyň razylygy esasynda hereket etmek üçin zerur bolup biler.",
        },
        { type: "text", text: "Şahsy maglumatlar şu maksatlar üçin işlenip bilner:" },
        {
          type: "list",
          items: [
            "hasap döretmek we dolandyrmak, Ulanyjyny kesgitlemek we hasabyň howpsuzlygyny saklamak;",
            "syýahat hyzmatlaryny gözlemek, bahalandyrmak, bronlaşdyrmak, resmileşdirmek, üýtgetmek, ýatyrmak we yzyna gaýtarmak;",
            "Ulanyjylar bilen habarlaşmak, tassyklamalary we syýahat baradaky täzelikleri ibermek hem-de müşderi goldawyny bermek;",
            "tölegleri, pul gaýtarmalary, çargbekleri, deňeşdirmeleri we galplygyň öňüni almak barlaglaryny amala aşyrmak;",
            "Türkmenistanda DMC hyzmatlaryny bermek, şol sanda ýerleşdirmek, transferler, ekskursiýalar, gid hyzmaty, çakylyklar boýunça goldaw we ýerli utgaşdyrma;",
            "korporatiw syýahat hyzmatlaryny, hasabatlary, tassyklamalary we syýahatçylara goldawy bermek hem-de dolandyrmak;",
            "hukuk, salgyt, buhgalter, awiasiýa, migrasiýa, sanksiýa, howpsuzlyk we kadalaşdyryjy talaplary ýerine ýetirmek;",
            "Saýty, Ulanyjylary, Kompaniýany we üpjün edijileri galplykdan, hyýanatçylykdan, kiberhadysalardan we bikanun hereketlerden goramak;",
            "Saýty, hyzmatlary we müşderi tejribesini seljermek, saklamak we gowulandyrmak;",
            "hukuk talaplaryny bellemek, amala aşyrmak ýa-da goramak we jedelleri çözmek; hem-de",
            "kanun rugsat berýän we Ulanyjynyň saýlawyna laýyk gelýän halatynda marketing habarlaryny ibermek.",
          ],
        },
        {
          type: "text",
          text: "Hukuk esasy razylyk bolan halatynda Ulanyjy ony islendik wagt yzyna alyp biler. Razylygyň yzyna alynmagy ondan öň amala aşyrylan işlemegiň kanunylygyna täsir etmeýär we başga kanuny esasda işlemäge päsgel bermeýär.",
        },
      ],
    },
    {
      title: "Beýleki ýolagçylar we kämillik ýaşyna ýetmedikler",
      blocks: [
        {
          type: "text",
          text: "Ulanyjy başga bir ýolagçy ýa-da syýahatçy barada şahsy maglumatlary diňe muňa ygtyýarly bolan halatynda berip biler. Ulanyjy şol şahsy işlemek barada habarly etmelidir, şu Syýasata giriş bermelidir hem-de onuň adyndan edilen islendik haýyşy ýa-da saýlawy dogry ýetirmelidir.",
        },
        {
          type: "text",
          text: "Syýahat bronlary çagalara degişli şahsy maglumatlary talap edip biler. Beýle maglumatlar diňe soralan hyzmatlary guramak we bermek, kanunyň ýa-da üpjün edijiniň talaplaryny ýerine ýetirmek, çaganyň bähbitlerini goramak we jogapkär uly adam bilen habarlaşmak üçin işlenýär.",
        },
        {
          type: "text",
          text: "Saýt çagalaryň özbaşdak hasap döretmegi ýa-da sargyt bermegi üçin niýetlenen däldir. Kämillik ýaşyna ýetmediginiň maglumatlaryny we degişli kanun tarapyndan talap edilýän razylygy ene-atasy, hossary ýa-da başga ygtyýarly uly adam bermelidir.",
        },
      ],
    },
    {
      title: "Tölegler we töleg üpjün edijileri",
      blocks: [
        {
          type: "text",
          text: "Tölegler garaşsyz banklar, ekwaýerler we töleg üpjün edijileri, şol sanda elýeterli bolan halatynda Stripe we PayPal tarapyndan işlenip bilner. Bu üpjün edijiler käbir şahsy maglumatlary öz gizlinlik habarnamalaryna we howpsuzlyk talaplaryna laýyklykda işleýärler.",
        },
        {
          type: "text",
          text: "Kartanyň maglumatlary göni töleg üpjün edijisiniň howpsuz interfeýsine girizilende Kompaniýa, adatça, kartanyň doly belgisini ýa-da howpsuzlyk kodyny (CVV/CVC) almaýar we saklamaýar. Kompaniýa töleg tokenini, kartanyň gizlenen maglumatlaryny, amalyň salgylanmasyny, töleýjiniň maglumatlaryny, ýagdaýy, möçberi, pul birligini hem-de deňeşdirmek, pul gaýtarmak, galplygyň öňüni almak we goldaw üçin zerur maglumatlary alyp biler.",
        },
        {
          type: "text",
          text: "Töleg üpjün edijileri, kartany çykaran banklar ýa-da karta ulgamlary şahsyýet, töwekgelçilik, sanksiýa ýa-da galplyk barlaglaryny geçirip bilerler hem-de öz düzgünlerine laýyklykda amaly ret edip, gijikdirip ýa-da yzyna gaýtaryp bilerler. Ulanyjylara töleg maglumatlaryny bermezden öň degişli üpjün edijiniň gizlinlik habarnamasy bilen tanyşmak maslahat berilýär.",
        },
      ],
    },
    {
      title: "Kukiler we meňzeş tehnologiýalar",
      blocks: [
        {
          type: "text",
          text: "Saýt işlemek, goramak, şahsylaşdyrmak we ölçemek üçin kukileri, pikselleri, ýerli ammary we meňzeş tehnologiýalary ulanyp biler. Kukiler brauzer ýapylanda möhleti gutarýan sessiýa kukileri ýa-da bellenen döwrüň dowamynda saklanýan hemişelik kukiler bolup biler.",
        },
        { type: "text", text: "Saýtyň sazlamalaryna baglylykda bu tehnologiýalar şular üçin ulanylyp bilner:" },
        {
          type: "list",
          items: [
            "hökmany zerur wezipeler: nawigasiýa, kesgitlemek, howpsuzlyk we bronlaşdyrmagyň dowamlylygy;",
            "funksional saýlawlar: dil, sebit we saklanan sazlamalar;",
            "analitika we öndürijiligi ölçemek, şol sanda sahypalaryň we mümkinçilikleriň nähili ulanylýandygyna düşünmek; hem-de",
            "beýle tehnologiýalar açyk we rugsat berlen halatynda mahabat ýa-da kampaniýany ölçemek.",
          ],
        },
        {
          type: "text",
          text: "Kanun talap edýän halatynda hökmany bolmadyk kukiler diňe Ulanyjy elýeterli razylyk mehanizmi arkaly saýlaw edenden soň ulanylýar. Ulanyjy kuki sazlamalaryny — göz öňünde tutulan bolsa — Saýtyň dolandyryş serişdelerinde ýa-da brauzerde üýtgedip biler. Käbir kukileriň petiklenmegi Saýtyň işleýşine täsir edip biler.",
        },
      ],
    },
    {
      title: "Şahsy maglumatlary alýanlar",
      blocks: [
        {
          type: "text",
          text: "Kompaniýa şahsy maglumatlary diňe şu Syýasatda beýan edilen maksatlar üçin zerur möçberde açyp biler, şol sanda şulara:",
        },
        {
          type: "list",
          items: [
            "awiakompaniýalara, myhmanhanalara, gatnadyjylara, transfer üpjün edijilerine, gidlere, tur operatorlaryna, ätiýaçlandyryjylara we beýleki üpjün edijilere;",
            "global paýlaýyş ulgamlaryna, bronlaşdyryş platformalaryna, NDC ýa-da API üpjün edijilerine we tehnologiýa hyzmatdaşlaryna;",
            "banklara, töleg üpjün edijilerine, karta ulgamlaryna, galplygyň öňüni almak we barlag üpjün edijilerine;",
            "degişli borçnamalar esasynda hereket edýän hosting, bulut, aragatnaşyk, analitika, müşderi goldawy we hünär hyzmatlaryny üpjün edijilere;",
            "hyzmat korporatiw ylalaşyk boýunça berilýän halatynda Ulanyjynyň iş berijisine, korporatiw syýahat menejerine ýa-da ygtyýarly syýahaty guraýja;",
            "soralan hyzmat üçin zerur we kanun rugsat berýän halatynda bagly kompaniýalara ýa-da işewür hyzmatdaşlara; hem-de",
            "açmak talap edilýän ýa-da kanuny esasda soralýan halatynda kazyýetlere, kadalaşdyryjy edaralara, hukuk goraýjy edaralara, serhet, migrasiýa, gümrük, salgyt we beýleki ygtyýarly edaralara.",
          ],
        },
        {
          type: "text",
          text: "Aýratyn operator hökmünde hereket edýän garaşsyz alyjylar öz işlemegini özbaşdak kesgitleýärler. Kompaniýanyň tabşyrygy boýunça hereket edýän hyzmat üpjün edijileri maglumatlary diňe ylalaşylan maksatlar üçin işlemäge we degişli goragy ulanmaga borçludyrlar.",
        },
        { type: "text", text: "Kompaniýa Ulanyjylaryň şahsy maglumatlaryny satmaýar we kärendesine bermeýär." },
      ],
    },
    {
      title: "Halkara geçirimler we maglumatlary saklamak",
      blocks: [
        {
          type: "text",
          text: "Syýahat hyzmatlary öz tebigaty boýunça halkara häsiýetlidir. Şonuň üçin şahsy maglumatlar degişli üpjün edijiniň, töleg üpjün edijisiniň, bronlaşdyryş platformasynyň, hyzmat hyzmatdaşynyň ýa-da döwlet edarasynyň ýerleşýän ýurtlaryna, şol sanda ugramak, üstaşyr geçmek ýa-da barmaly ýurda geçirilip we ol ýerde işlenip bilner.",
        },
        {
          type: "text",
          text: "Alyjy ýurtdaky kanunçylyk we şahsy maglumatlaryň goralyş derejesi Ulanyjynyň ýurdundakydan tapawutlanyp biler. Degişli kanun geçirim mehanizmini ýa-da başga goragy talap edýän halatynda Kompaniýa laýyk kanuny esasy, şertnamalaýyn goragy, razylygy ýa-da rugsat berlen başga çäräni ulanýar.",
        },
        {
          type: "text",
          text: "Kompaniýa şahsy maglumatlary ýygnamagy, ulgamlaşdyrmagy, toplamagy, saklamagy, takyklamagy we ulanmagy Türkmenistanyň degişli talaplaryna, şol sanda maglumat binýatlaryna ýa-da Türkmenistanda saklamaga degişli kadalara laýyklykda guraýar. Hyzmaty bermek serhetüsti geçirimi talap edýän halatynda diňe şol maksat üçin esasly zerur maglumatlar geçirilýär.",
        },
      ],
    },
    {
      title: "Şahsy maglumatlaryň aýratyn toparlary",
      blocks: [
        {
          type: "text",
          text: "Kompaniýa jyns ýa-da etnik gelip çykyşyny, syýasy garaýyşlaryny, dini ýa-da pelsepe ynançlaryny, kärdeşler arkalaşygyna agzalygyny, genetiki ýa-da biometriki kesgitleýjilerini, saglyk maglumatlaryny ýa-da şahsyň jyns durmuşy hem-de jyns ugurlylygy baradaky maglumatlary — beýle maglumatlar soralan hyzmat üçin hakykatdan-da zerur bolmasa ýa-da kanun tarapyndan talap edilmese — bilkastlaýyn soramaýar.",
        },
        {
          type: "text",
          text: "Ýörite kömegi, laýyk ýerleşdirmegi, iýmiti, ätiýaçlandyryş goldawyny ýa-da başga syýahat şertini soramak üçin saglyk, elýeterlilik, iýmit, hereket ukyby ýa-da beýleki duýgur maglumatlar gerek bolup biler. Kompaniýa beýle maglumatlary diňe zerur möçberde we kanuny esasda işleýär; oňa Ulanyjynyň aýdyň razylygy, möhüm bähbitleri goramak ýa-da kanuny borçlary ýerine ýetirmek girip biler.",
        },
        { type: "text", text: "Ulanyjylara soralan hyzmat üçin zerur bolmadyk duýgur maglumatlary bermezlik maslahat berilýär." },
      ],
    },
    {
      title: "Saklaýyş möhletleri",
      blocks: [
        {
          type: "text",
          text: "Kompaniýa şahsy maglumatlary diňe olaryň ýygnalan maksady üçin esasly zerur bolan möhletde saklaýar; oňa hyzmatlary bermek, goldaw, buhgalter hasaby, salgytlar, audit, galplygyň öňüni almak, jedelleri çözmek hem-de kanunyň ýa-da üpjün edijiniň talaplaryny berjaý etmek girýär.",
        },
        {
          type: "text",
          text: "Ulanylýan saklaýyş möhleti maglumatlaryň toparyna, gatnaşyklaryň häsiýetine we dowamlylygyna, şertnamalaýyn hem-de kanuny hak islegi möhletlerine, kanuny saklaýyş borçlaryna, howpsuzlyk talaplaryna, şikaýatyň ýa-da jedeliň bardygyna we Ulanyjynyň islendik esasly haýyşyna baglydyr.",
        },
        {
          type: "text",
          text: "Şahsy maglumatlar mundan beýläk gerek bolmasa, olar pozulýar, şahsyýetsizlendirilýär ýa-da adaty ulanyşdan aýrylýar, kanun boýunça saklamagyň dowam etdirilmegi talap edilýän ýa-da rugsat berilýän halatlardan başga. Ätiýaçlyk nusgalary çäkli döwrüň dowamynda saklanyp biler we adaty girişden goralýar.",
        },
      ],
    },
    {
      title: "Maglumatlaryň howpsuzlygy",
      blocks: [
        {
          type: "text",
          text: "Kompaniýa şahsy maglumatlary tötänleýin ýa-da bikanun ýok edilmekden, ýitirilmekden, üýtgedilmekden, açylmakdan, elýeterli edilmekden ýa-da hyýanatçylykly ulanylmakdan goramak üçin niýetlenen esasly guramaçylyk we tehniki çäreleri ulanýar. Çärelere girişi dolandyrmak, kesgitlemek, zerur halatynda geçirilende şifrlemek, howpsuz töleg interfeýsleri, žurnal ýöretmek, ätiýaçlyk nusgalary, işgärleriň gizlinlik borçlary we hyzmat üpjün edijilerine gözegçilik girip biler.",
        },
        {
          type: "text",
          text: "Geçirmegiň ýa-da saklamagyň hiç bir usuly doly howpsuz däldir. Ulanyjylar hasabynyň giriş maglumatlaryny we tassyklaýyş kodlaryny goramaly, ynamdar enjamlary hem-de torlary ulanmaly we ygtyýarsyz girişe ýa-da hyýanatçylyga şübhelenseler, Kompaniýa haýal etmän habar bermeli.",
        },
        {
          type: "text",
          text: "Şahsy maglumatlar bilen bagly hadysa ýüze çykan halatynda Kompaniýa ony derňeýär, täsirini azaldýar we resminamalaşdyrýar hem-de degişli kanun talap edýän bolsa, ejir çeken şahslara ýa-da ygtyýarly edaralara habar berýär.",
        },
      ],
    },
    {
      title: "Ulanyjynyň hukuklary",
      blocks: [
        { type: "text", text: "Degişli kanuna we rugsat berlen çäklendirmelere laýyklykda Ulanyjynyň şu hukuklary bolup biler:" },
        {
          type: "list",
          items: [
            "şahsy maglumatlarynyň işlenilýändigi we nähili işlenilýändigi barada maglumat almak;",
            "şahsy maglumatlaryna giriş ýa-da olaryň nusgasyny soramak;",
            "nädogry ýa-da doly däl maglumatlary düzetmegi ýa-da doldurmagy soramak;",
            "maglumatlaryň pozulmagyny, ýok edilmegini, şahsyýetsizlendirilmegini ýa-da işlenmeginiň çäklendirilmegini soramak;",
            "käbir esaslar boýunça, şol sanda göni marketing boýunça işlenmegine garşylyk bildirmek;",
            "işlemek razylyga esaslanýan bolsa, razylygy yzyna almak;",
            "kanun beýle hukugy göz öňünde tutýan bolsa, käbir maglumatlary geçirmäge amatly görnüşde almak;",
            "degişli halatynda diňe awtomatik işlemäge esaslanan çözgüde adamyň gatnaşmagyny soramak; hem-de",
            "şahsy maglumatlary goramak boýunça ygtyýarly ýa-da gözegçilik edarasyna şikaýat etmek.",
          ],
        },
        {
          type: "text",
          text: "Haýyş 19-njy bölümdäki habarlaşmak maglumatlary arkaly berlip bilner. Şahsy maglumatlary goramak üçin Kompaniýa şahsyýeti we ygtyýarlygy tassyklamak üçin esasly zerur maglumatlary sorap biler. Kompaniýa degişli kanun tarapyndan bellenen möhletde jogap berýär hem-de kanuny aýratynlyk bolan halatynda haýyşy ret edip ýa-da çäklendirip biler.",
        },
        {
          type: "text",
          text: "Käbir maglumatlar brony tamamlamak, kanuny berjaý etmek, hökmany ýazgylary saklamak, galplygyň öňüni almak, jedeli çözmek ýa-da hukuk talaplaryny bellemek, amala aşyrmak hem-de goramak üçin zerur bolmagynda galýan halatynda derrew pozulyp bilinmeýär.",
        },
      ],
    },
    {
      title: "Marketing habarlary",
      blocks: [
        {
          type: "text",
          text: "Ulanyjy razylyk beren ýa-da başga kanuny esas beýle habarlaşmaga rugsat berýän halatynda Kompaniýa FlyAshgabat ýa-da saýlanan hyzmatdaşlaryň hyzmatlary barada täzelikleri, teklipleri we maglumatlary iberip biler.",
        },
        {
          type: "text",
          text: "Ulanyjy islendik wagt habardaky ýazylmagy ýatyrmak usulyny ulanyp ýa-da Kompaniýa ýüz tutup, ondan ýüz öwrüp biler. Marketingden ýüz öwürmek hasap, bron, töleg, howpsuzlyk habarnamasy ýa-da müşderi hyzmatynyň haýyşy üçin zerur bolan iş habarlaryny bes etmeýär.",
        },
      ],
    },
    {
      title: "Awtomatik barlaglar",
      blocks: [
        {
          type: "text",
          text: "Saýt, töleg üpjün edijileri ýa-da galplygyň öňüni almak boýunça hyzmatdaşlar şübheli amallary, hasabyň hyýanatçylykly ulanylmagyny, gaýtalanan bronlary, sanksiýa bilen bagly ýagdaýlary ýa-da howpsuzlyk howplaryny ýüze çykarmak üçin awtomatik kadalary ýa-da töwekgelçilik görkezijilerini ulanyp bilerler.",
        },
        {
          type: "text",
          text: "Awtomatik barlagyň netijesinde goşmaça tassyklama soralyp, wagtlaýyn gijikdirme bolup ýa-da el bilen seljermä ugradylyp bilner. Degişli kanun diňe awtomatik işlemäge esaslanan hem-de hukuk ýa-da şoňa meňzeş ähmiýetli netijeleri bolan çözgüt babatda hukuklary göz öňünde tutýan halatynda Ulanyjy adamyň gatnaşmagyny sorap, öz garaýşyny beýan edip we çözgüde garşylyk bildirip biler.",
        },
      ],
    },
    {
      title: "Üçünji taraplaryň saýtlary we hyzmatlary",
      blocks: [
        {
          type: "text",
          text: "Saýtda üpjün edijiler, töleg üpjün edijileri, sosial ulgamlar ýa-da beýleki üçünji taraplar tarapyndan dolandyrylýan saýtlara we hyzmatlara salgylar, gurnalan gurallar ýa-da geçirmeler bolup biler. Olaryň gizlinlik tejribesi Kompaniýanyň gönüden-göni gözegçiliginden daşdadyr.",
        },
        {
          type: "text",
          text: "Ulanyjylara şahsy maglumatlary bermezden öň her üçünji tarap hyzmatynyň gizlinlik habarnamasy we şertleri bilen tanyşmak maslahat berilýär. Kompaniýa üçünji tarapyň amala aşyrýan garaşsyz işlemegi üçin jogapkärçilik çekmeýär, jogapkärçiligiň degişli kanun boýunça aýrylyp bilinmeýän halatlaryndan başga.",
        },
      ],
    },
    {
      title: "Şu Syýasata üýtgetmeler",
      blocks: [
        {
          type: "text",
          text: "Kompaniýa Saýtdaky, hyzmatlardaky, işlemekdäki, kanuny talaplardaky ýa-da işewürlik tejribesindäki üýtgeşmeleri şöhlelendirmek üçin şu Syýasaty wagtal-wagtal täzeläp biler. Häzirki wersiýa https://flyashgabat.com/privacy-policy-info salgysynda çap edilýär we öz güýje girýän senesini görkezýär.",
        },
        {
          type: "text",
          text: "Üýtgetme Ulanyjylaryň hukuklaryna ýa-da şahsy maglumatlaryň işlenilişine düýpli täsir edýän bolsa, Kompaniýa goşmaça habar berer ýa-da kanun talap edýän halatynda razylyk alar. Degişli kanun aýratyn tassyklaýjy hereketi talap edýän halatynda täzelenmeden soň Saýtdan peýdalanmagy dowam etdirmek razylyk hasaplanmaýar.",
        },
      ],
    },
    {
      title: "Habarlaşmak üçin maglumatlar",
      blocks: [
        {
          type: "text",
          text: "Gizlinlik, şahsy maglumatlary işlemek ýa-da hukuklary amala aşyrmak boýunça soraglar üçin aşakdaky maglumatlar arkaly Kompaniýa ýüz tutuň:",
        },
        {
          type: "table",
          rows: [
            { label: "Maglumatlaryň operatory", value: "«Jahankeshde Hyzmat» hususy kärhanasy" },
            { label: "Iňlis dilindäki ady", value: "Jahankeshde Hyzmat P.E." },
            { label: "Hasaba alnan salgysy", value: "Türkmenistan, Mary ş., Gorkut-Ata köçesi, 5A" },
            { label: "Işewürlik salgysy", value: "Türkmenistan, Mary ş., Gorkut-Ata köçesi, 5A" },
            { label: "Telefon", value: "+993 522 4 55 44", href: "tel:+99352245544" },
            { label: "Ykjam telefon", value: "+993 61 826345", href: "tel:+99361826345" },
            { label: "E-poçta", value: "info@flyashgabat.com" },
            { label: "Web-saýt", value: "https://www.flyashgabat.com" },
          ],
        },
      ],
    },
  ],
};

const privacyPolicyContent = { en, ru, tm };

export default privacyPolicyContent;
